// Custom Scripts
import "bootstrap";
import "waypoints/lib/noframework.waypoints";
import $ from "jquery";
import imagesLoaded from "imagesloaded";
import "./jquery.visible.js"

imagesLoaded.makeJQueryPlugin($);

$(function () {
  /*
    faders for the headers/work/callout copy
  */
  var $headerElem = $("#main-nav"),
    $footerElem = $("footer"),
    $articleElem = $("article.page.type-page"),
    handleWaypoints = function () {
      if ($(".inview").length) {
        $(".inview").each(function () {
          let delay = $(this).data("offset") ? $(this).data("offset") : "92%";
          let easeType = $(this).data("ease") ? $(this).data("ease") : "fadeIn";
          let waypoint = new Waypoint({
            element: this,
            handler: function (direction) {
              if (direction == "down" && !$(this.element).hasClass(easeType)) {
                $(this.element).addClass(easeType);
              }
            },
            offset: delay
          });
        });
      }
    };

  $headerElem.addClass('start');
  $articleElem.addClass('start');
  $footerElem.addClass('start');

  handleWaypoints();

  /*
    smooth scrolling functions
  */

  function scrollToAnchor(el, event) {
    const $selector = $(el);
    event.preventDefault();
    $('html, body').animate({
      scrollTop: $selector.offset().top
    }, 1500)
  }

  let location;
  const HOME_PAGE = 'home';
  const CONTACT_PAGE = 'contact';
  const WORK_PAGE = 'work';

  if (window.location.pathname === '/') location = HOME_PAGE;
  if (window.location.pathname.startsWith('/contact')) location = CONTACT_PAGE;
  if (window.location.pathname.startsWith('/work')) location = WORK_PAGE;

  $(".nav-work-link").on("click", (evt) => {
    closeExpandedMenu();
    switch (location) {
      case HOME_PAGE:
        scrollToAnchor('#work', evt);
        break;
      default:
        window.location.href = '/#work';
        break;
    };
  });

  $(".nav-contact-link").on("click", (evt) => {
    closeExpandedMenu();
    window.location.href = '/contact/';
    return;

    switch (location) {
      case HOME_PAGE:
        scrollToAnchor('#contact', evt);
        break;
      case CONTACT_PAGE:
        break;
      default:
        window.location.href = '/contact/';
        break;
    };
  });

  /*

  .nav-link {
      color: $black;
      &:hover {
        color: $blue;
      }
    }

    */

  // Handle Arrow Scroll Top
  $("#return-to-top").on("click", (evt) => {
    scrollToAnchor('#top', evt);
  });

  // 
  $(".navbar-brand").on("click", (evt) => {
    switch (location) {
      case HOME_PAGE:
        scrollToAnchor('#work', evt);
        break;
      default:
        window.location.href = '/';
        break;
    };
  });

  // more-carat - nudge page down
  $("#more-carat").on("click", (evt) => {
    scrollToAnchor('#work', evt);
    // evt.preventDefault();
    // $("#more-carat").hide()
    // $('html,body').animate({
    //   scrollTop: '+=200px'
    // })
  });

  // Scroll to Top carat functionality
  $(window).on('scroll', () => {
    if ($(this).scrollTop() >= 600) {
      $("#return-to-top").addClass("active");
    } else {
      $("#return-to-top").removeClass("active");
    }
  });

  // hide more-carat if we've scrolled down
  $(window).on('scroll', () => {
    if ($('#work').visible(true)) {
      $("#more-carat").hide()
    } else {
      $("#more-carat").show()
    }
  });

  // reformat the main nav when we're scrolling and stuff
  var navBarHt = 50;

  const scrollingElements = [
    "#main-nav",
    "#main-nav .navbar-brand",
    "#main-nav .navbar",
    "#main-nav #menu-main-menu .nav-item .nav-link"
  ]

  $(window).on('scroll', () => {
    let currentScrollPos = window.pageYOffset;
    if (currentScrollPos > navBarHt) {
      for (let el of scrollingElements) {
        $(el).addClass("scrolled")
      }
      $("#main-nav .navbar-brand .light").removeClass('d-block');
      $("#main-nav .navbar-brand .dark").addClass('d-block');
    } else {
      for (let el of scrollingElements) {
        $(el).removeClass("scrolled")
      }
      $("#main-nav .navbar-brand .light").addClass('d-block');
      $("#main-nav .navbar-brand .dark").removeClass('d-block');
    }
  }).trigger("scroll");

  // small device expanded menu
  // close overlay menu
  $("#close-btn").on("click", () => {
    closeExpandedMenu();
    // if ($('#expanded-menu').hasClass('show')) {
    //   $("body").removeClass("scroll-hidden");
    //   $("#main-nav .navbar-toggler").trigger("click");
    // }

  });

  $("#expanded-menu").on("show.bs.collapse", () => {
    $("body").addClass("scroll-hidden");
  });

  
  function closeExpandedMenu() {
    if($('#expanded-menu').hasClass('show')) {
      $("body").removeClass("scroll-hidden");
      $("#main-nav .navbar-toggler").trigger("click");
    }
  }

});